import React, { useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { FcInspection } from "react-icons/fc";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { Formik, Form } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { WebinarFeedbackInfo } from "../../../SchemaInfo/info";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { toast } from "react-toastify";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import Stars from "react-stars";
import { webinarFeedbackSchema } from "../../../Schemas/webinar/webinar_feedback";

const CreateWebinarFeedback = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const handleSubmit = (values, actions) => {
    values.id = id;
    performRequest("POST", "/webinar/webinarFeedback", values)
      .then((res) => {
        if (res.status === 201) {
          if (res.data.feedbackRating === 5) {
            toast.success(
              <div>
                <p>Thank you for your feedback! 🙌</p>
                <p>
                  We'd love to hear more — please take a moment to{" "}
                  <a
                    href="https://www.google.com/search?q=kryzen+biotech&rlz=1C5CHFA_enIN1156IN1156&oq=kryzen+biotech&gs_lcrp=EgZjaHJvbWUyCQgAEEUYORiABDIHCAEQABiABDIHCAIQABiABDIHCAMQABiABDINCAQQLhivARjHARiABDIHCAUQABiABDIHCAYQABiABDIKCAcQABiABBiiBDIKCAgQABiABBiiBDIKCAkQABiABBiiBNIBCDY1NzJqMGo0qAIAsAIB&sourceid=chrome&ie=UTF-8&lqi=Cg5rcnl6ZW4gYmlvdGVjaEijhqHs0q2AgAhaGBAAEAEYABgBIg5rcnl6ZW4gYmlvdGVjaJIBFGFncmljdWx0dXJhbF9zZXJ2aWNlqgFZCg0vZy8xMWZucXNqanQzEAEqEiIOa3J5emVuIGJpb3RlY2goADIeEAEiGsG9magUgLLGJObe05YlRO9VjTj_UScy9TV0MhIQAiIOa3J5emVuIGJpb3RlY2g#rlimm=11140704873877456003&lrd=0x3bc24552ca88aa3d:0x9a9bbc0e8aedc483,3,,,,"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#4caf50",
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    leave us a review on google
                  </a>
                  .
                </p>
              </div>,
              {
                position: "top-center",
                autoClose: 80000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  backgroundColor: "white",
                  color: "black",
                },
              }
            );
          } else {
            Toast(
              "success",
              "Thank you for your feedback. We'll make some thoughtful improvements."
            );

            navigate(`/`);
          }
        } else {
          Toast("error", "Error while creating feedback");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };
  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    {" "}
                    <FcInspection className="fs-2 me-1" />
                    Webinar Feedback
                  </h2>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="ps-3 pt-3">
                <h1
                  className="text-center"
                  style={{
                    color: "rgb(131, 129, 69)",
                    fontWeight: "700",
                    fontSize: "30px",
                  }}
                >
                  Webinar Feedback
                </h1>
                <p
                  className="fs-3 pb-0 text-center"
                  style={{ color: "rgb(57, 57, 48)", fontWeight: "500" }}
                >
                  We would love to hear your thoughts, suggestions, concerns or
                  problems with webinar so we can improve!
                </p>
                <div className="text-center">
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752558738/xpb4b57zcxuscosms20w_lyaaoe_ndl1n9.webp"
                    alt="feedback image"
                    style={{ height: "40px" }}
                  ></img>
                </div>
              </div>
              <hr></hr>
              <Formik
                initialValues={WebinarFeedbackInfo}
                validationSchema={webinarFeedbackSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="mb-3 row">
                        <label className="form-label col-lg-3 col-md-3 col-sm-12  fs-3 required">
                          Feedback Rating
                        </label>
                        <div className="col-lg-9 col-md-9 col-sm-12  mt-0  ms-sm-0 ms-lg-0  ms-md-0">
                          <div>
                            <label htmlFor="">
                              <Stars
                                count={5}
                                size={30}
                                value={props.values.feedbackRating}
                                onChange={(newValue) =>
                                  props.setFieldValue(
                                    "feedbackRating",
                                    newValue
                                  )
                                }
                              />
                            </label>
                          </div>
                          {props.touched.feedbackRating &&
                            props.errors.feedbackRating && (
                              <p className="text-danger">
                                {props.errors.feedbackRating}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="form-label col-lg-3 col-md-3 col-sm-12 fs-3 required">
                          Describe Your Feedback
                        </label>
                        <div className="col-lg-9 col-md-9 col-sm-12">
                          <CustomTextArea name="feedback" rows="5" />
                          <div className="mt-2">
                            {props.touched.feedback &&
                              props.errors.feedback && (
                                <p className="text-danger">
                                  {props.errors.feedback}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <button className="btn mx-1 mt-2 btn-success">
                          SUBMIT FEEDBACK
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
    // <div className="page min-vh-100 bg-light">
    //   <div className="page-wrapper py-5">
    //     <div className="container-xl">
    //       {/* Webinar Ended Card */}
    //       <div className="card mb-4">
    //         <div className="card-body text-center p-5">
    //           <h1 className="card-title mb-3">Webinar Ended</h1>
    //           <p className="text-muted mb-4">
    //             Thank you for joining our webinar on the future of hydroponic
    //             farming! We hope you’re inspired to explore sustainable
    //             agriculture.
    //           </p>
    //           <a href="/" className="btn btn-blue">
    //             Return to Home
    //           </a>
    //         </div>
    //       </div>

    //       {/* Discover Hydroponic Farming Card */}
    //       <div className="card mb-4">
    //         <div className="card-header">
    //           <h2 className="card-title">Discover Hydroponic Farming</h2>
    //         </div>
    //         <div className="card-body">
    //           <p className="mb-3">
    //             Hydroponic farming is revolutionizing agriculture by growing
    //             plants without soil, using nutrient-rich water solutions. This
    //             innovative method allows farmers to produce fresh, high-quality
    //             crops like leafy greens, herbs, and fruits in controlled
    //             environments, maximizing space and resources.
    //           </p>
    //           <p className="mb-3">
    //             With hydroponics, you can achieve up to 5 times higher yields
    //             than traditional farming while using 90% less water. It’s
    //             perfect for urban farmers, small-scale growers, and anyone
    //             looking to cultivate sustainably. Our mission is to empower
    //             new-age farmers with cutting-edge technology and training to
    //             build profitable, eco-friendly farms.
    //           </p>
    //           <p className="mb-3">
    //             From vertical farming setups to AI-driven farm management, the
    //             future of agriculture is here. Join our community to learn how
    //             you can start your own hydroponic journey and contribute to a
    //             greener planet.
    //           </p>
    //           <a href="https://www.kryzen.com/" className="btn btn-green mt-3">
    //             Explore Our Training Programs
    //           </a>
    //         </div>
    //       </div>

    //       {/* Training and Services Card */}
    //       <div className="card mb-4">
    //         <div className="card-header">
    //           <h2 className="card-title">Our Training Courses and Services</h2>
    //         </div>
    //         <div className="card-body">
    //           <p className="mb-4">
    //             Kryzen Biotech offers a range of training programs and services
    //             to help you succeed in hydroponic farming. Whether you’re a
    //             beginner or a professional, our courses and solutions are
    //             designed to empower you with practical skills and innovative
    //             technology.
    //           </p>

    //           {/* Training Courses Accordion */}
    //           <div className="accordion mb-4" id="accordion-courses">
    //             <div className="accordion-item">
    //               <h3 className="accordion-header">
    //                 <button
    //                   className="accordion-button"
    //                   type="button"
    //                   onClick={() => toggleSection("courses")}
    //                   aria-expanded={openSection === "courses"}
    //                 >
    //                   Training Courses
    //                 </button>
    //               </h3>
    //               {openSection === "courses" && (
    //                 <div className="accordion-body">
    //                   <ul className="list-unstyled ms-4">
    //                     <li className="mb-2">
    //                       <strong>Hydroponic Masterclass (Online):</strong>{" "}
    //                       Comprehensive e-learning program with community and
    //                       software support, covering all aspects of hydroponic
    //                       farming.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Hands-On Farm Training (Offline):</strong>{" "}
    //                       Two-day practical workshop at our Satara farm,
    //                       focusing on hands-on experience and farm management.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Know Hydroponics (Crash Course):</strong>{" "}
    //                       Short course for urban farmers to learn the basics of
    //                       soilless farming.
    //                     </li>
    //                   </ul>
    //                 </div>
    //               )}
    //             </div>
    //           </div>

    //           {/* Services Accordion */}
    //           <div className="accordion" id="accordion-services">
    //             <div className="accordion-item">
    //               <h3 className="accordion-header">
    //                 <button
    //                   className="accordion-button"
    //                   type="button"
    //                   onClick={() => toggleSection("services")}
    //                   aria-expanded={openSection === "services"}
    //                 >
    //                   Services
    //                 </button>
    //               </h3>
    //               {openSection === "services" && (
    //                 <div className="accordion-body">
    //                   <ul className="list-unstyled ms-4">
    //                     <li className="mb-2">
    //                       <strong>
    //                         Turnkey Commercial Hydroponic Farm Setup:
    //                       </strong>{" "}
    //                       End-to-end project development with customized,
    //                       high-ROI designs.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Rural and Urban Farming Technology:</strong>{" "}
    //                       AI-based automation and vertical farming solutions for
    //                       diverse environments.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Crop Research Lab:</strong> R&D services to
    //                       optimize crop growth and yield.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Soilless Growing Solutions:</strong> Expertise
    //                       in NFT systems, grow bags, and Dutch buckets.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Mega Farming Projects:</strong> Large-scale
    //                       hydroponic farm development for commercial clients.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Agro-CSR Planning:</strong> Consulting for
    //                       sustainable farming in CSR initiatives.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Grants & Subsidies Assistance:</strong>{" "}
    //                       Support for securing NHM & NHB subsidies with
    //                       documentation.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Site Inspection Kit:</strong> Tools to assess
    //                       land suitability for hydroponic projects.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>HydroNEXT Farm Management Software:</strong>{" "}
    //                       Software for efficient farm operations and automation.
    //                     </li>
    //                     <li className="mb-2">
    //                       <strong>Hydroponic Nutrient Chart:</strong> Guidance
    //                       on nutrient solutions for optimal plant growth.
    //                     </li>
    //                   </ul>
    //                 </div>
    //               )}
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //     {/* Footer */}
    //     <Footer />
    //   </div>
    // </div>
  );
};

export default CreateWebinarFeedback;
